module.exports = __webpack_public_path__ + "img/stock6.5c80ed39.png";